<template xmlns="http://www.w3.org/1999/html">
    <div>

        <main role="main">

            <div class="container-fluid">


                <div class="row mt-2 mb-2">
                    <div class="col-md-12">

                        <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

                        <div class="row">
                            <div class="col-md-12 mb-5">
                                <b-nav tabs>
                                    <b-nav-item @click="routerGoTo('transactions')" >{{$t('text.apmPages.transactionsLabel')}}</b-nav-item>
                                    <b-nav-item @click="routerGoTo('errors')" active>{{$t('text.apmPages.errors')}}</b-nav-item>
                                    <b-nav-item @click="routerGoTo('metrics')" >{{$t('text.apmPages.metrics')}}</b-nav-item>
                                </b-nav>
                            </div>
                        </div>

                        <h3 class="mb-5">
                            {{this.$route.params.serviceName}}
                        </h3>

                        <div class="row mt-3 mb-3">

                            <div class="col-md-6">
                                <VueCtkDateTimePicker id="startTime" format="YYYY-MM-DDTHH:mm:ssZ" class="withLabel"
                                                      formatted="DD.MM.YYYY, HH:mm"
                                                      v-model="startTimestamp"
                                                      @input="updateTimes()"
                                                      :locale="$t('text.globals.datePickerLocale')"
                                                      :label="$t('text.apmPages.chooseDate')"
                                                      :button-now-translation="$t('text.globals.now')"
                                />
                            </div>

                            <div class="col-md-6">
                                <VueCtkDateTimePicker id="endTime" format="YYYY-MM-DDTHH:mm:ssZ" class="withLabel"
                                                      formatted="DD.MM.YYYY, HH:mm" v-model="endTimestamp"
                                                      @input="updateTimes()"
                                                      :locale="$t('text.globals.datePickerLocale')"
                                                      :label="$t('text.apmPages.chooseDate')"
                                                      :button-now-translation="$t('text.globals.now')"
                                />
                            </div>
                        </div>


                        <div class="row mt-3" id="wrapper">

                            <div class="col-md-12">
                                <div id="chart-bar" class="mt-3">
                                    <label for="error-occurrences">{{$t('text.apmPages.errorOccurrences')}}</label>
                                    <apexchart id="error-occurrences" type="bar" height="300"
                                               :options="errorOccurrencesChartOptions"
                                               :series="errorOccurrencesChartSeries"
                                               :key="errorOccurrencesChartDataLoaded"/>
                                </div>
                            </div>
                        </div>


                        <div>

                            <vue-good-table
                                    id="error-list"
                                    styleClass="vgt-table table table-hover table-striped"
                                    :columns="columns"
                                    :rows="rows">

                                <div slot="emptystate">
                                    <div class="text-center"><i class="fa fa-exclamation-triangle"></i> <em>{{$t('text.globals.noData')}}</em></div>
                                </div>
                                <template slot="table-row" slot-scope="props">
                                    <span v-if="props.column.field == 'groupId'">
                                        <a href="javascript:void(0)" class="" @click="onCellClick(props)"><pre style="font-size: 0.8rem; color: #007bff">{{props.row.groupId.substr(0,4)}}</pre></a>
                                    </span>

                                    <span v-else-if="props.column.field == 'message'">

                                        <a href="javascript:void(0)" class="" @click="onCellClick(props)">
                                            <pre :title="props.row.message.replace('\n','.')" class="mb-1" style="font-size: 0.8rem; color: #007bff; max-width: 400px; text-overflow: ellipsis; overflow: hidden; display: inline-block;">{{props.row.message.replace('\n','.')}}</pre></a>
                                        <pre>{{props.row.culprit ? props.row.culprit : 'N/A'}}</pre>
                                    </span>

                                    <span v-else-if="props.column.field == 'latestOccurrenceAt'">
                                        {{moment(props.row.latestOccurrenceAt).fromNow()}}
                                    </span>

                                    <span v-else>
                                        {{props.row[props.column.field]}}
                                    </span>

                                </template>


                            </vue-good-table>
                        </div>
                    </div>


                </div>


            </div>

        </main>

    </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faHome} from '@fortawesome/free-solid-svg-icons'
    import SidebarNavigation from '../components/SidebarNavigation';
    import {VueGoodTable} from 'vue-good-table';
    import axios from 'axios/index';

    library.add(faHome);


    export default {
        name: 'Transactions',
        components: {
            SidebarNavigation
        },
        data() {
            return {
                startTimestamp: null,
                endTimestamp: null,
                startTimeDate: null,
                endTimeDate: null,
                errorOccurrencesChartDataLoaded: false,
                errorOccurrencesChartSeries: [{
                    name: '',
                    data: []
                }],
                errorOccurrencesChartOptions: {
                    colors: ['#80bcd2'],
                    plotOptions: {
                        bar: {
                            vertical: true,
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    chart: {
                        id: 'errorOccurrences'
                    },
                    xaxis: {
                        type: "datetime",
                        categories: []
                    },
                    yaxis: {
                        labels: {
                            formatter: function (value) {
                                return value + " occ.";
                            }
                        }
                    },
                    stroke: {
                        width: 1
                    }
                },

                //table
                columns: [
                    {
                        label: this.$t('text.apmPages.tableColumns.groupId'),
                        field: 'groupId',
                        type: 'text',
                        width: '150px',
                        sortable: true
                    },
                    {
                        label: this.$t('text.apmPages.tableColumns.message'),
                        field: 'message',
                        type: 'text',
                        sortable: true,

                    },
                    {
                        label: this.$t('text.apmPages.tableColumns.occurrenceCount'),
                        field: 'occurrenceCount',
                        type: 'text',
                        width: '170px',
                        sortable: true
                    },
                    {
                        label: this.$t('text.apmPages.tableColumns.latestOccurrenceAt'),
                        field: 'latestOccurrenceAt',
                        type: 'text',
                        width: '200px',
                        sortable: true
                    }
                ],
                rows: [],
                breadcrumbItems: [
                    {
                        text: this.$t('text.apmPages.apmLabel'),
                        href: '#/apm'
                    },
                    {
                        text: this.$route.params.serviceName,
                        href: '#/transactions/' + encodeURIComponent(this.$route.params.serviceName)
                    },
                    {
                        text: this.$t('text.apmPages.errors'),
                        active: true
                    }
                ]
            }
        },
        mounted() {
            this.initDate();
        },

        watch: {
            '$route'(to, from) {
                // react to route changes...

                this.initDate();


            }

        },

        methods: {

            updateTimes(){

                this.$router.push({
                    path: "",
                    query:{
                        start: encodeURIComponent(this.startTimestamp),
                        end: encodeURIComponent(this.endTimestamp)
                    }
                });


            },

            routerGoTo(where){

                this.$router.push("/" + where + "/"+ this.$route.params.serviceName + "?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp));

            },

            getData() {
                const _this = this;

                this.errorOccurrencesChartDataLoaded = false;

                console.log("cas zacetka: ", this.startTimestamp);
                console.log("cas konca: ", this.endTimestamp);

                axios.get(config.kibana + this.$route.params.serviceName + "/errors/distribution?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp) + "&uiFilters=%7B%7D", {headers: {}})
                    .then((res) => {

                        // errors graf
                        console.log("response za transaction duration graf:", _.map(res.data.buckets, 'count'));

                        _this.errorOccurrencesChartSeries[0] = {
                            name: "test",
                            data: _.map(res.data.buckets, 'count')
                        };

                        for (let i = 0; i < res.data.buckets.length; i++) {
                            _this.errorOccurrencesChartOptions.xaxis.categories[i] = res.data.buckets[i].key;
                        }

                        _this.errorOccurrencesChartDataLoaded = true;
                        console.log("errorOccurrencesChartDataLoaded", _this.errorOccurrencesChartDataLoaded);
                        console.log("_this.errorOccurrencesChartOptions", _this.errorOccurrencesChartOptions);

                    })
                    .catch((error) => {
                        console.log(error);
                    });


                //tabela
                axios.get(config.kibana + this.$route.params.serviceName + "/errors?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp) + "&uiFilters=%7B%7D", {headers: {}})
                    .then((res) => {
                        console.log("response za tabelo:", res.data);
                        this.rows = res.data;
                    })
                    .catch((error) => {
                        console.log(error);
                    });

            },


            initDate() {

                if (this.$route.query.start == null && this.$route.query.end == null) {
                    this.endTimeDate = new Date();
                    this.startTimeDate = new Date();
                    this.startTimeDate.setDate(this.endTimeDate.getDate() - 1);
                    this.startTimestamp = this.startTimeDate.toISOString();
                    this.endTimestamp = this.endTimeDate.toISOString();

                    this.$router.push({
                        path: "",
                        query:{
                            start: encodeURIComponent(this.startTimestamp),
                            end: encodeURIComponent(this.endTimestamp)
                        }
                    });

                } else {

                    this.startTimestamp = decodeURIComponent(this.$route.query.start);
                    this.endTimestamp = decodeURIComponent(this.$route.query.end);


                }

                this.breadcrumbItems[0].href = "#/apm/" + "?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp);
                this.breadcrumbItems[1].href = "#/transactions/" + encodeURIComponent(this.$route.params.serviceName) + "?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp);
                this.getData();
            },


            formatMiliseconds(value) {
                return Math.round(value / 1000) + " " + this.$t('text.apmPages.ms');
            },

            formatTransactionsPerMinute(value) {
                return +parseFloat(value).toFixed(1) + " " + this.$t('text.apmPages.tpm');
            },

            onCellClick(params) {
                console.log(params);
                let errorGroup = params.row.groupId;

                this.$router.push('/errors/' + this.$route.params.serviceName + '/' + encodeURIComponent(errorGroup) + "?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp));
            }

        },
        beforeCreate: function () {
            document.body.className = 'transactions';
        }
    };
</script>



// WEBPACK FOOTER //
// src/pages/ApmErrors.vue